/**
 * @generated SignedSource<<fca34214df57e91bcc6b333185773418>>
 * @relayHash 60d19155b9cdae4e64b4f7c449f4752d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2ae6071654511a4527a0abd92d665dfad5552a83d6d7c2b1c9bb45d8c1b6d8eb

import type { ConcreteRequest, Query } from 'relay-runtime';
export type Nav4RecommendationsQuery$variables = {
  cloudId: string;
};
export type Nav4RecommendationsQuery$data = {
  readonly growthRecommendations: {
    readonly recommendations: {
      readonly data?: ReadonlyArray<{
        readonly entityId?: string;
      }> | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly jira: {
    readonly canCreateProject: boolean | null | undefined;
  } | null | undefined;
};
export type Nav4RecommendationsQuery = {
  response: Nav4RecommendationsQuery$data;
  variables: Nav4RecommendationsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = {
  "concreteType": "JiraQuery",
  "kind": "LinkedField",
  "name": "jira",
  "plural": false,
  "selections": [
    {
      "alias": "canCreateProject",
      "args": [
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        },
        {
          "kind": "Literal",
          "name": "type",
          "value": "CREATE_PROJECT"
        }
      ],
      "kind": "ScalarField",
      "name": "canPerform"
    }
  ]
},
v2 = [
  {
    "fields": [
      {
        "kind": "Literal",
        "name": "product",
        "value": "jira"
      },
      {
        "kind": "Variable",
        "name": "tenantId",
        "variableName": "cloudId"
      },
      {
        "kind": "Literal",
        "name": "useCase",
        "value": "jiraProjectMenuRecommendations"
      }
    ],
    "kind": "ObjectValue",
    "name": "context"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 2
  }
],
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "entityId"
    }
  ],
  "type": "GrowthRecJiraTemplateRecommendation"
},
v4 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "Nav4RecommendationsQuery",
    "selections": [
      (v1/*: any*/),
      {
        "concreteType": "GrowthRecQuery",
        "kind": "LinkedField",
        "name": "growthRecommendations",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "recommendations",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "data",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/)
                    ]
                  }
                ],
                "type": "GrowthRecRecommendations"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Nav4RecommendationsQuery",
    "selections": [
      (v1/*: any*/),
      {
        "concreteType": "GrowthRecQuery",
        "kind": "LinkedField",
        "name": "growthRecommendations",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "recommendations",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "data",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      (v3/*: any*/)
                    ]
                  }
                ],
                "type": "GrowthRecRecommendations"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "2ae6071654511a4527a0abd92d665dfad5552a83d6d7c2b1c9bb45d8c1b6d8eb",
    "metadata": {},
    "name": "Nav4RecommendationsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "37e580905a6bb12dfab4ae64833a88d6";

export default node;
